import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';
import { DictionaryDeposit } from './../../models';

export function useMineralGroups() {
  return useAutocompleteSource<DictionaryDeposit>({
    url: `${EvidenceAPI.DICTIONARY_MINERAL_GROUP}/autocomplete`,
  });
}
